package provider

import androidx.compose.runtime.*
import androidx.compose.ui.graphics.vector.*
import api.*
import compose.assets.*
import compose.assets.svg.*

val LocalLocalization = staticCompositionLocalOf<Localization> { error("Localization not defined") }

interface Localization {

    val language: LanguageType

    fun change(new: LanguageType)
}

val LanguageType.icon: ImageVector
    get() = when (this) {
        LanguageType.Bosnia -> Svg.FlagBa
        LanguageType.Czech -> Svg.FlagCs
        LanguageType.English -> Svg.FlagGb
        LanguageType.Hrvatska -> Svg.FlagHr
        LanguageType.Slovak -> Svg.FlagSk
        LanguageType.Bulgarian -> Svg.FlagBg
        LanguageType.Portuguese -> Svg.FlagPt
        LanguageType.French -> Svg.FlagFr
        LanguageType.Italian -> Svg.FlagIt
        LanguageType.Spanish -> Svg.FlagEs
        LanguageType.German -> Svg.FlagDe
    }

/**
 * Languages sorted alphabetically by native name, diacritics ignored (Čeština among C),
 * non-Latin scripts (Български) after Latin ones. Use for every language picker / tab row.
 */
val LanguageType.Companion.allSorted: List<LanguageType> by lazy {
    LanguageType.all.sortedWith(compareBy({ !it.title.first().isLatinLetter() }, { it.title.sortKey() }))
}

private const val DIACRITICS = "ÁÀÂÄÃČĆÇĎĐÉÈÊËĚÍÌÎÏĽĹŁŇÑÓÒÔÖÕŘŔŠŚŤÚÙÛÜŮÝŽŹŻ"
private const val DIACRITICS_BASE = "AAAAACCCDDEEEEEIIIILLLNNOOOOORRSSTUUUUUYZZZ"

private fun Char.isLatinLetter(): Boolean = uppercaseChar().let { it in 'A'..'Z' || it in DIACRITICS }

private fun String.sortKey(): String = uppercase().map { c ->
    DIACRITICS.indexOf(c).let { i -> if (i >= 0) DIACRITICS_BASE[i] else c }
}.joinToString("")
